module.exports = __webpack_public_path__ + "static/assets/7ae17c967f58ead058c188ed61eef847.png";